import { ReactQueryDevtools as ReactQueryDevToolsLocal } from "@tanstack/react-query-devtools";
import { lazy, Suspense, useEffect, useState } from "react";

const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/lib/index.prod.js").then(
    ({ ReactQueryDevtools }) => ({ default: ReactQueryDevtools }),
  ),
);

/**
 * Render the React Query Devtools in development and (on demand) in production
 */
export const ReactQueryDevTools = () => {
  const [showTools, setShowTools] = useState(false);

  useEffect(() => {
    // @ts-expect-error This function isn't called from the app, it's just for
    // debugging purposes in production
    globalThis.toggleReactQueryDevTools = () => setShowTools((prev) => !prev);
  }, []);

  if (showTools) {
    return (
      <Suspense fallback={null}>
        <ReactQueryDevtoolsProduction />
      </Suspense>
    );
  } else {
    // This is a no-op in production
    return <ReactQueryDevToolsLocal />;
  }
};
